import { Component, Output, EventEmitter } from "@angular/core";
import {
  VAIconRegistryService,
  closeCircle,
  infoCircle,
  arrowCircleRight,
  arrowCircleLeft,
  guidance,
  chevronLeft,
  chevronRight,
} from "@va/core-library/icons";
import { CompanyDataService } from "../../company-page/company-data.service";
import { HttpClient } from "@angular/common/http";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import { Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { GlobalSubheaderDataService } from "../../global-subheader/global-subheader-data.service";

@Component({
  selector: "app-company-announcements",
  templateUrl: "./company-announcements.component.html",
  styleUrls: ["./company-announcements.component.scss"],
  host: { class: "documents-viewer-page" },
})
export class CompanyAnnouncementsComponent {
  @Output() closeClicked: EventEmitter<void> = new EventEmitter();
  @Output() onNextGuidanceClicked: EventEmitter<void> = new EventEmitter();
  @Output() onPrevGuidanceClicked: EventEmitter<void> = new EventEmitter();
  data;
  page;
  cut = "SAR";
  documentId;
  companyId = "";
  fileType = "filling";
  filingsError;
  filingFileType;
  currentGuidance = 0;
  guidanceCount = 0;
  hasGuidance: boolean;
  guidanceList;
  gettingPDFURL = false;
  viewModalSrc: SafeResourceUrl;
  legacyUrl = `${window.caUrl}/app`;
  currentTicker;
  filingsHeading;
  documentType;
  datePublish;
  ticker;
  period;

  isLeftSidebarActive = false;
  isRightSidebarActive = false;

  //subscribers
  routeParamSubscriber: Subscription;

  constructor(
    private iconRegistry: VAIconRegistryService,
    private service: CompanyDataService,
    private http: HttpClient,
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private fBService: GlobalSubheaderDataService,
  ) {
    this.iconRegistry.registerIcons([
      closeCircle,
      infoCircle,
      arrowCircleRight,
      arrowCircleLeft,
      guidance,
      chevronLeft,
      chevronRight,
    ]);
  }

  ngOnInit() {
    this.routeParamSubscriber = this.route.params.subscribe((paramData) => {
      this.currentTicker = paramData.ticker
        ? paramData.ticker.toUpperCase()
        : undefined;

      this.page = paramData.page;
      this.documentId = paramData.documentId;
      this.fileType = paramData.fileType;
      this.ticker = paramData.ticker;

      // apis
      this.getFbarDetails();
      this.getDocumnetViewerDetails();
    });
  }

  closeDialog() {
    this.closeClicked.emit();
  }
  onNextGuidance() {
    if (this.currentGuidance < this.guidanceCount) {
      this.currentGuidance += 1;
      const guidanceId =
        this.guidanceList[this.currentGuidance - 1].start_tag_id;

      this.scrollToElementInIframeWithOffset(guidanceId);

      const currFilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(`bkmk_${guidanceId}`);
      const allfilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(
          "bkmk_filings_span_class",
        );
      for (let i = 0; i < allfilingsDocClass.length; i++) {
        allfilingsDocClass[i].style.backgroundColor = "#FFEFCB";
      }
      for (let i = 0; i < currFilingsDocClass.length; i++) {
        currFilingsDocClass[i].style.backgroundColor = "#FFC846";
      }
    }
  }
  onPrevGuidance() {
    if (this.currentGuidance > 1) {
      this.currentGuidance -= 1;
      const guidanceId =
        this.guidanceList[this.currentGuidance - 1].start_tag_id;

      this.scrollToElementInIframeWithOffset(guidanceId);
      const currFilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(`bkmk_${guidanceId}`);
      const allfilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(
          "bkmk_filings_span_class",
        );
      for (let i = 0; i < allfilingsDocClass.length; i++) {
        allfilingsDocClass[i].style.backgroundColor = "#FFEFCB";
      }
      for (let i = 0; i < currFilingsDocClass.length; i++) {
        currFilingsDocClass[i].style.backgroundColor = "#FFC846";
      }
    }
  }

  handleleftsidebarClick() {
    this.isLeftSidebarActive = !this.isLeftSidebarActive;
  }

  handleRightSidebarClick() {
    this.isRightSidebarActive = !this.isRightSidebarActive;
  }

  getDocumnetViewerDetails() {
    this.currentGuidance = 0;
    this.guidanceCount = 0;

    const params = {
      downloadType: "filings",
      documentId: this.documentId,
      companyId: this.companyId,
      pg: this.page,
      cut: this.cut,
      ticker: this.ticker,
    };
    this.filingsError = false;

    this.service.getViewModelSrc(params).subscribe((msg) => {
      this.filingFileType = msg["fileType"];
      const param = {
        documentId: this.documentId,
      };

      if (msg["fileType"] === "htm" || msg["fileType"] === "html") {
        //load modal with src
        const options = {
          responseType: "text" as const,
        };
        this.hasGuidance = msg.guidance;
        if (msg.guidance) {
          this.service.getGuidanceData(param).subscribe(
            (response) => {
              // logic for guidance stuff
              const doc =
                document.getElementById("filingsFrame")["contentWindow"]
                  .document;
              if (doc && response) {
                doc.open();
                doc.write(response);
                doc.close();
                setTimeout(() => {
                  this.service.getGuidanceList(param).subscribe((response) => {
                    this.guidanceList = response["data"].guidances;
                    this.guidanceCount = this.guidanceList.length;
                    const filingsDocClass = document
                      .getElementById("filingsFrame")
                      ["contentWindow"].document.getElementsByClassName(
                        "bkmk_filings_span_class",
                      );
                    for (let i = 0; i < filingsDocClass.length; i++) {
                      filingsDocClass[i].style.backgroundColor = "#FFEFCB";
                    }
                  });
                }, 1000);
              }

              // this.loadGuidance();
            },
            (error) => {
              console.error(error);
            },
          );
        } else {
          this.http.get(msg.url, options).subscribe(
            (htmlData) => {
              const doc =
                document.getElementById("filingsFrame")["contentWindow"]
                  .document;
              if (doc && htmlData) {
                doc.open();
                doc.write(htmlData);
                doc.close();
              }
            },
            (error) => {
              console.error(error);
            },
          );
        }
        // this.viewModalSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
        //   msg.url,
        // );
      }
      if (msg["fileType"] === "pdf") {
        const options = {
          responseType: "arraybuffer",
        };
        const filingsParams = {
          documentId: this.documentId,
        };
        this.gettingPDFURL = true;
        this.service.getPDFFilings(filingsParams, options).subscribe(
          (pdfData) => {
            if (pdfData["status"] === "error") {
              console.error(pdfData["message"]);
            } else {
              const file = new Blob([pdfData], { type: "application/pdf" });
              const fileURL = URL.createObjectURL(file);
              this.viewModalSrc =
                this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
              this.filingsError = false;
              this.gettingPDFURL = false;
              // document
              //   .getElementById("AMSFilingsFrame")
              //   .setAttribute("src", fileURL);
            }
          },
          (error) => {
            console.error(error);
          },
        );
      }
      if (msg.status === "error") {
        //show error
        this.filingsError = true;
      }

      if (msg.force_logout) {
        window.location.href = `${this.legacyUrl}/homepage/?force_logout=true`;
      }
    });
  }

  getFbarDetails() {
    const cutForModelDetails = "SAR";
    const params = `/api/modeldetail?cut=${cutForModelDetails}&source=Filings&company=${this.ticker}&documentid=${this.documentId}`;
    this.fBService.getFbarModelDetails(params).subscribe((res) => {
      if (res.status === "success") {
        this.documentType = res.document_type;
        this.datePublish = res.docDate;
        this.period = res.statedPeriod;
      }
    });
  }

  scrollToElementInIframeWithOffset(elementSelector, offset = 20) {
    const iframe = document.getElementById("filingsFrame") as HTMLIFrameElement;
    if (!iframe) {
      return;
    }
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    const targetElement = iframeDoc.getElementById(elementSelector);

    if (targetElement) {
      const elementPosition = targetElement.getBoundingClientRect().top;

      const offsetPosition =
        elementPosition + iframe.contentWindow.scrollY - offset;

      iframe.contentWindow.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }
}
